export default __webpack_public_path__ + "static/media/experts-ico.352adb37.svg";